import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Card, Col, Container, Form, Image, InputGroup, Row, Table } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import { useCookies } from "react-cookie";
import "../general.css";

const Dictionary = ({ en }) => {
  const [cookies, setCookie, removeCookie] = useCookies();
  const [meaning, setMeaning] = useState(["", "", "", "", ""]);

  function getItem(num, id, n) {
    let str = "";
    let cnt = 0;
    for (let i = 0; i < n; i++) {
      // console.log(id[i][0], id[i][1])
      if (id[i][0] === "") {
        str = str + id[i][1];
        cnt++
      } else if (cookies.crossWW[id[i][0]][id[i][1]]) {
        str = str + cookies.crossWW[id[i][0]][id[i][1]];
        cnt++
      } else {
        str = str + "＿";
      }
    }
    let m = meaning;
    const ja_k = ["のみみす゛", "みす゛", "ざむざむ", "いす゛み", "すいげん"]
    const ja_h = ["のミミス゛", "ミス゛", "ザムザム", "イス゛ミ", "スイげン"]
    const eng = ["drinking water", "water", "Zamzam", "spring", "fountainhead"]
    if (cnt === n && (str === ja_k[num] || str === ja_h[num])) {
      m[num] = eng[num];
    } else {
      m[num] = "";
    }
    return (str);
  }

  return (
    <>
      <div>
        <p>
          <b>{en ? "Arabic words appear in historical books" : "書物に登場するアラビア文字"}</b>
        </p>
        <p>
          {en ? (
            <>
              <small>By filling out crossword, these Arabic words will convert according to the letters you have input.<br />Let's solve the crossword! Good luck to you!!</small>
            </>
          ) : (
            <>
              <small>クロスワードを埋めることで、<br />対応する文字に自動で変換されるぞ！<br />がんばってクロスワードを解こう！</small>
            </>
          )}
        </p>
        <Card className='mt-3'>
          <Card.Body className='p-1'>
            <Table>
              <thead>
                <tr>
                  {en ? (
                    <>
                      <th>Arabic Words</th>
                      <th className='text-start'>Pronounce</th>
                      <th>Meaning</th>
                    </>
                  ) : (
                    <>
                      <th>アラビア文字</th>
                      <th className='text-start'>読み方</th>
                    </>
                  )}
                </tr>
              </thead>
              <tbody >
                <tr>
                  <td>نوميميزو</td>
                  <td className='text-start'>{cookies.crossWW ? getItem(0, [["", "の"], ["ミナレット", 0], ["ミナレット", 0], ["ムスリム", 1], ["", "゛"]], 5) : "の＿＿＿"}</td>
                  {en ? <td>{meaning[0]}</td> : <></>}
                </tr>
                <tr>
                  <td>ميزو</td>
                  <td className='text-start'>{cookies.crossWW ? getItem(1, [["ミナレット", 0], ["ムスリム", 1], ["", "゛"]], 3) : "＿＿゛"}</td>
                  {en ? <td>{meaning[1]}</td> : <></>}
                </tr>
                <tr>
                  <td>زمزم</td>
                  <td className='text-start'>{cookies.crossWW ? getItem(2, [["ザフラーン", "0"], ["サウジアラムコ", 5], ["ザフラーン", 0], ["ムハンマド", 0]], 4) : "＿＿＿＿"}</td>
                  {en ? <td>{meaning[2]}</td> : <></>}
                </tr>
                <tr>
                  <td>إيزومي</td>
                  <td className='text-start'>{cookies.crossWW ? getItem(3, [["マダインサーレハ", 2], ["ムスリム", 1], ["", "゛"], ["ミナレット", 0]], 4) : "＿＿゛＿"}</td>
                  {en ? <td>{meaning[3]}</td> : <></>}
                </tr>
                <tr>
                  <td>سويجن</td>
                  <td className='text-start'>{cookies.crossWW ? getItem(4, [["マスマク城", 1], ["マダインサーレハ", 2], ["", "げ"], ["コーラン", 3]], 4) : "＿＿げ＿"}</td>
                  {en ? <td>{meaning[4]}</td> : <></>}
                </tr>
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </div>
    </>
  )
}

export default Dictionary;
